<ul class="progress-steps">
  @for (step of steps; track step.label) {
  <li [attr.class]="step.className">
    <mat-icon [svgIcon]="step.className"></mat-icon>
    <span [innerHtml]="step.label"></span>
  </li>
  }
</ul>
<mat-progress-bar mode="determinate" [value]="compPercent"></mat-progress-bar>
